import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Modal from "react-modal";
import AnimeList from "./AnimeList";
import "@fontsource/montserrat";
import LineWithDot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";

import TotalMentorsTable from "./TotalMentorsTable";
import MyMentorsTable from "./MyMentorsTable";
import { getMyMentorsCounter } from "../dependencies/action";
// import Button from "../../AdminDashboard/Button";
import machines from "./rightbottom.svg";
import GlobalSelectComponent from "../../../../common/SelectComponent";
import viewAllMentorListButton from "../../../../../assets/svg/dashboard/viewAllMentorListButton.svg";
import { isLoading } from "../../../../common/dependencies/action/action";
// : "#838186"
import clsx from "clsx";
import {
  GET_NAMES_DATA,
  MENTOR_LIST,
  MENTOR_SEARCH_REQUEST_LIST,
  MY_MENTORS_COUNTER,
  MY_MENTORS_LIST,
  SEARCH_LIST_COUNTERS,
} from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import Pagination from "react-js-pagination";
import { connect } from "react-redux";
import allMentorListImage from "../../../../../assets/svg/dashboard/Icon_Mentor_White.svg";
import { type } from "@testing-library/user-event/dist/type";
import ModalFilters from "../../../../common/modalFilters/index";
import { Button, IconButton } from "@material-ui/core";
import Select from "react-select";
import { State } from "country-state-city";
import dropdownicon from "../../../../../assets/images/arrow.png";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "20px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "5px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontfamily: "Montserrat !important",
    fontWeight: 600,
    padding: "10px 17px",
    borderRadius: "8px",
    fontSize: "18px",
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "60px",
    [theme.breakpoints.down("md")]: {
      marginTop: "15px",
    },
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "18px",
  },
  lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDotLower: {
    color: "#816aaf",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: "14px",
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  select2: {
    fontSize: "16px",
    width: "200px",
    whiteSpace: "nowrap",
    textAlign: "left",
    marginRight: "10px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    marginLeft: "60px",
    [theme.breakpoints.down("md")]: {
      marginLeft: "30px",
      marginTop: "15px",
    },
  },
  lowerButtonsContainer: {
    padding: "0 35%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  sendRequestButton: {
    height: "80px !important",
    maxWidth: "none",
  },
  tableContainer: {
    padding: "0 0 20px 0",
    margin: "0 7% 50px 7%",
    [theme.breakpoints.down("md")]: {
      margin: "0 0 50px 0",
    },
  },
  filterContainer: {
    padding: "50px 7% 0 7%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  select2Container: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginBottom: "15px",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplayMobile: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
  },
}));

// 838186
const types = {
  TOTAL_MENTORS: "TOTAL_MENTORS",
  MY_MENTORS: "MY_MENTORS",
  MY_REQUESTS: "MY_REQUESTS",
};

const UpperDisplaySurface = (props) => {
  const { selected, setSelected } = props;

  const [data, setData] = useState();
  const { tablePaginate, getMyMentorsCounter } = props;
  // useEffect(() => {
  //   let params = {
  //     startupId : JSON.parse(localStorage.getItem("SavedLoggedInData")).id
  //    }
  //    getMyMentorsCounter(params)
  // },[])
  useEffect(() => {
    localStorage.setItem("startupAllMentorList", "startupAllMentorList");

    setTimeout(() => {
      localStorage.removeItem("myRequests");
      localStorage.removeItem("mentorStartupRequest");
      localStorage.removeItem("startUpRequests");
      localStorage.removeItem("CohortStartupRequest");
      localStorage.removeItem("cohortMentorshipsStartup");
    }, 1000);

    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    props.openLoader();
    // axios({
    //   url: MY_MENTORS_COUNTER,
    //   method: "POST",
    //   data: {
    //     requestedBy: value?.id,
    //   },
    // })
    api
      .POST(MY_MENTORS_COUNTER, {
        requestedBy: value?.id,
      })
      .then((res) => {
        setData(res?.data?.data);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, []);

  const classes = useStyles();

  const SelectedContainer = (props) => (
    <Box className={classes.lineWithDotContainer}>
      <p className={classes.lineWithDotUpper}>{props.content}</p>
      <img
        src={LineWithDot}
        className={classes.lineWithDot}
        alt="line with dot"
      />
    </Box>
  );

  const UnselectedContainer = (props) => (
    <Typography
      className={classes.cursorOnHover}
      onClick={() => {
        setSelected(props.type);
      }}
      style={{
        fontFamily: "Montserrat",
        fontSize: "18px",
        fontWeight: "bold",
        color: "#838186",
      }}
    >
      {props.content}
    </Typography>
  );

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container spacing={2} className="foruatchanronly">
          <Grid
            item
            xs={12}
            className={[
              classes.upperDisplayMobile,
              "mentorshiptooltiphideformbagain",
            ]}
          >
            <img
              src={allMentorListImage}
              style={{ height: "100px" }}
              alt="allmentorlistimage"
            />
            <Box
              className={classes.messageIconWrapper}
              style={{ width: "auto" }}
            >
              <Typography
                className={clsx(classes.requestsStatusTy, "ttlmentos")}
                style={{ fontFamily: "Montserrat" }}
              >
                MENTORS
              </Typography>
            </Box>
            {selected === types.TOTAL_MENTORS ? (
              <div className="newuserTooltip totmentorsactive">
                <SelectedContainer
                  type={types.TOTAL_MENTORS}
                  content={
                    "TOTAL MENTORS : " +
                    `${tablePaginate && tablePaginate?.total}`
                  }
                  className="totmentors2 ttlmentos"
                />
                <span className="tooltiptext   tooltip-bottom requirement-03">
                  Click to View Total Mentors List
                </span>
              </div>
            ) : (
              <div className="newuserTooltip totmentorsinactive">
                <UnselectedContainer
                  className="ttlmentos"
                  type={types.TOTAL_MENTORS}
                  content={
                    "TOTAL MENTORS : " +
                    `${tablePaginate && tablePaginate?.total}`
                  }
                />
                <span className="tooltiptext   tooltip-bottom requirement-03">
                  Click to View Total Mentors List
                </span>
              </div>
            )}
            {selected === types.MY_REQUESTS ? (
              <div className="newuserTooltip myreqactive">
                <SelectedContainer
                  type={types.MY_REQUESTS}
                  content={
                    "MY REQUESTS : " +
                    `${tablePaginate && tablePaginate?.requestSent}`
                  }
                />
                <span className="tooltiptext   tooltip-bottom requirement-03">
                  Click to View My Mentors List
                </span>
              </div>
            ) : (
              <div className="newuserTooltip myreqinactive">
                <UnselectedContainer
                  type={types.MY_REQUESTS}
                  content={
                    "MY REQUESTS : " +
                    `${tablePaginate && tablePaginate?.requestSent}`
                  }
                />
                <span className="tooltiptext   tooltip-bottom requirement-03">
                  Click to View My Request List
                </span>
              </div>
            )}
            {selected === types.MY_MENTORS ? (
              <div className="newuserTooltip mymentoractive">
                <SelectedContainer
                  type={types.MY_MENTORS}
                  content={
                    "MY MENTORS : " +
                    `${tablePaginate && tablePaginate?.myMentors}`
                  }
                />
                <span className="tooltiptext   tooltip-bottom requirement-03">
                  Click to View My Mentors List
                </span>
              </div>
            ) : (
              <div className="newuserTooltip mymentorinactive">
                <UnselectedContainer
                  type={types.MY_MENTORS}
                  content={
                    "MY MENTORS : " +
                    `${tablePaginate && tablePaginate?.myMentors}`
                  }
                />
                <span className="tooltiptext   tooltip-bottom requirement-03">
                  Click to View My Mentors List
                </span>
              </div>
            )}

            {/* <div className="newuserTooltip">
                <SelectedContainer
                  type={types.MY_REQUESTS}
                  content={
                    "MY REQUESTS : " +
                    `${tablePaginate && tablePaginate?.requestSent}`
                  }
                />
                <span
                  className="tooltiptext   tooltip-bottom"
                  style={{ left: "82px", width: "230px", top: "35px" }}
                >
                  Click to View Total Mentors List
                </span>
              </div> */}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const AllMentorList = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const { getStepperTooltipData, getStepperData } = props;
  const classes = useStyles(0);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const { tablePaginate, getMyMentorsCounter } = props;
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [currentPage3, setCurrentPage3] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [selected, setSelected] = useState(types.TOTAL_MENTORS);
  const [totalMentors, setTotalMentors] = useState();
  const [modalVisibility, setModalVisibility] = useState(false);
  const [mentorID, setMentorID] = useState("");
  const [isParentData, setIsParentData] = useState("");
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterIndustryKeyword, setFilterIndustryKeyword] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterFunctionKeyword, setFilterFunctionKeyword] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterMentorName, setFilterMentorName] = useState("");
  const [filterMentorNameData, setFilterMentorNameData] = useState();

  // const [modalIsOpen,setModalIsOpen] = useState(false);
  const [isShown, setIsShown] = useState(false);

  const getMentorList = () => {
    // axios({
    //   url: GET_NAMES_DATA,
    //   method: "post",
    //   data: {
    //     listKey: "Mentor",
    //   },
    // })
    api
      .POST(GET_NAMES_DATA, {
        listKey: "Mentor",
      })
      .then((res) => {
        setFilterMentorNameData(res.data?.data);
      })
      .catch((err) => {});
  };
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  React.useEffect(() => {
    html.style.overflow = "auto";

    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    getMentorList();
    props.openLoader();
    // axios({
    //   url: MENTOR_LIST,
    //   method: "POST",
    //   data: {
    //     startupId: value?.id,
    //     industry: "",
    //     function: "",
    //     sortKey: "name",
    //     sortOrder: "ASC",
    //     stage: null,
    //     state: null,
    //     country: null,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 10,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MENTOR_LIST, {
        startupId: value?.id,
        industry: "",
        function: "",
        sortKey: "name",
        sortOrder: "ASC",
        stage: null,
        state: null,
        country: null,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 10,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        setData(res.data.data);
        setPaginationData(res.data.paginate);
        setTotalMentors(res.data.paginate?.totalElements);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, []);
  React.useEffect(() => {
    let params = {
      startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getMyMentorsCounter(params);
  }, []);
  React.useEffect(() => {}, [tablePaginate]);
  React.useEffect(() => {
    props.openLoader();
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    let data = {};
    if (filterFunction.value) {
      data.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      data.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      data.stage = filterStage.value;
    }
    if (filterFunctionKeyword.value) {
      data.sub_function = [filterFunctionKeyword.value];
    }
    if (filterIndustryKeyword.value) {
      data.sub_industry = [filterIndustryKeyword.value];
    }
    if (filterState.value) {
      data.state = filterState.value;
    }
    if (selected === types.MY_MENTORS) {
      // axios({
      //   url: MY_MENTORS_LIST,
      //   method: "POST",
      //   data: {
      //     requestedBy: value?.id,
      //     ...data,
      //     pageFilter: {
      //       currentPage: currentPage2 - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MY_MENTORS_LIST, {
          requestedBy: value?.id,
          ...data,
          pageFilter: {
            currentPage: currentPage2 - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data.data);
          setPaginationData(res.data.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    } else if (selected === types.MY_REQUESTS) {
      // axios({
      //   url: MENTOR_LIST,
      //   method: "POST",
      //   data: {
      //     status: "REQUESTSENT",
      //     ...data,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     pageFilter: {
      //       currentPage: currentPage3 - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // });
      api.POST(MENTOR_LIST, {
        status: "REQUESTSENT",
        ...data,
        sortKey: "name",
        sortOrder: "ASC",
        pageFilter: {
          currentPage: currentPage3 - 1,
          includeCount: true,
          pageSize: 10,
          sortField: "name",
          sortOrder: "ASC",
        },
      });
    } else {
      // axios({
      //   url: MENTOR_LIST,
      //   method: "POST",
      //   data: {
      //     ...data,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     startupId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      //     pageFilter: {
      //       currentPage: currentPage - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MENTOR_LIST, {
          ...data,
          sortKey: "name",
          sortOrder: "ASC",
          startupId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
          pageFilter: {
            currentPage: currentPage - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data.data);
          setPaginationData(res.data.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    }
  }, [currentPage, currentPage2, currentPage3]);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  React.useEffect(() => {
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    props.openLoader();
    let data = {};
    if (filterFunction.value) {
      data.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      data.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      data.stage = filterStage.value;
    }
    if (filterFunctionKeyword.value) {
      data.sub_function = [filterFunctionKeyword.value];
    }
    if (filterIndustryKeyword.value) {
      data.sub_industry = [filterIndustryKeyword.value];
    }
    if (filterState.value) {
      data.state = filterState.value;
    }
    if (filterMentorName.value) {
      data.searchField = filterMentorName.value;
    }
    if (selected === types.MY_MENTORS) {
      // axios({
      //   url: MY_MENTORS_LIST,
      //   method: "POST",
      //   data: {
      //     requestedBy: value?.id,
      //     ...data,
      //     pageFilter: {
      //       currentPage: currentPage2 - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MY_MENTORS_LIST, {
          requestedBy: value?.id,
          ...data,
          pageFilter: {
            currentPage: currentPage2 - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data.data);
          setPaginationData(res.data.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    } else if (selected === types.MY_REQUESTS) {
      // axios({
      //   url: MENTOR_LIST,
      //   method: "POST",
      //   data: {
      //     startupId: value?.id,
      //     status: "REQUESTSENT",
      //     ...data,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     pageFilter: {
      //       currentPage: currentPage3 - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MENTOR_LIST, {
          startupId: value?.id,
          status: "REQUESTSENT",
          ...data,
          sortKey: "name",
          sortOrder: "ASC",
          pageFilter: {
            currentPage: currentPage3 - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data.data);
          setPaginationData(res.data.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        })
        .then((res) => {
          setData(res.data?.data);
          setPaginationData(res.data?.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    } else {
      // axios({
      //   url: MENTOR_LIST,
      //   method: "POST",
      //   data: {
      //     ...data,
      //     sortField: "name",
      //     sortOrder: "ASC",
      //     startupId: value?.id,
      //     pageFilter: {
      //       currentPage: currentPage - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MENTOR_LIST, {
          ...data,
          sortField: "name",
          sortOrder: "ASC",
          startupId: value?.id,
          pageFilter: {
            currentPage: currentPage - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data.data);
          setPaginationData(res.data.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    }
  }, [selected, filterMentorName]);

  const handleChangeOfPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleChangeOfPage2 = (pageNumber) => {
    setCurrentPage2(pageNumber);
  };
  const handleChangeOfPage3 = (pageNumber) => {
    setCurrentPage3(pageNumber);
  };

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => index !== 0);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };

  const addNewItem = (arr, label) => {
    arr?.unshift({ value: "", label: label });
    return arr;
  };

  const states = State.getStatesOfCountry("IN").map((item) => ({
    value: item.name,
    label: item.name,
  }));

  const handleClickOfFilter = () => {
    props.openLoader();
    let data = {};
    if (filterFunction.value) {
      data.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      data.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      data.stage = filterStage.value;
    }
    if (filterFunctionKeyword.value) {
      data.sub_function = [filterFunctionKeyword.value];
    }
    if (filterIndustryKeyword.value) {
      data.sub_industry = [filterIndustryKeyword.value];
    }
    if (filterState.value) {
      data.state = filterState.value;
    }
    if (filterMentorName.value) {
      data.searchField = filterMentorName.value;
    }
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    if (selected === types.TOTAL_MENTORS) {
      setCurrentPage(1);
      // axios({
      //   url: MENTOR_LIST,
      //   method: "POST",
      //   data: {
      //     ...data,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //     pageFilter: {
      //       currentPage: currentPage - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MENTOR_LIST, {
          ...data,
          sortKey: "name",
          sortOrder: "ASC",
          startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          pageFilter: {
            currentPage: currentPage - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res?.data?.data);
          setPaginationData(res?.data?.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    } else if (selected === types.MY_MENTORS) {
      setCurrentPage2(1);
      // axios({
      //   url: MY_MENTORS_LIST,
      //   method: "POST",
      //   data: {
      //     requestedBy: value?.id,
      //     ...data,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     pageFilter: {
      //       currentPage: currentPage2 - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MY_MENTORS_LIST, {
          requestedBy: value?.id,
          ...data,
          sortKey: "name",
          sortOrder: "ASC",
          pageFilter: {
            currentPage: currentPage2 - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data?.data);
          setPaginationData(res.data?.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    } else {
      setCurrentPage3(1);
      // axios({
      //   url: MENTOR_LIST,
      //   method: "POST",
      //   data: {
      //     startupId: value?.id,
      //     status: "REQUESTSENT",
      //     ...data,
      //     sortKey: "name",
      //     sortOrder: "ASC",
      //     pageFilter: {
      //       currentPage: currentPage3 - 1,
      //       includeCount: true,
      //       pageSize: 10,
      //       sortField: "name",
      //       sortOrder: "ASC",
      //     },
      //   },
      // })
      api
        .POST(MENTOR_LIST, {
          startupId: value?.id,
          status: "REQUESTSENT",
          ...data,
          sortKey: "name",
          sortOrder: "ASC",
          pageFilter: {
            currentPage: currentPage3 - 1,
            includeCount: true,
            pageSize: 10,
            sortField: "name",
            sortOrder: "ASC",
          },
        })
        .then((res) => {
          setData(res.data?.data);
          setPaginationData(res.data?.paginate);
          props.closeLoader();
        })
        .catch((err) => {
          props.closeLoader();
        });
    }
  };

  return (
    <Box className={classes.root}>
      <div className="iconWith-heading startupmentorlistdiv">
        <div style={{ width: "100%" }}>
          <Typography
            className={[
              classes.headingOne,
              "fadeInDown",
              "wow",
              "mentorshipreqhead1",
            ]}
          >
            MAARG Portal by Startup India
          </Typography>
          <Typography
            className={[
              classes.headingTwo,
              "fadeInDown",
              "wow",
              "mentorshipreqhead2",
            ]}
          >
            STARTUP DASHBOARD: ALL MENTORS LIST
          </Typography>
        </div>
        <div
          className="tooltipshow eyeIcon"
          // onClick={() => {
          //   // html.style.overflow = "hidden";

          //   if (html.style.overflow == "auto") {
          //     html.style.overflow = "hidden";
          //   } else {
          //     html.style.overflow = "auto";
          //   }
          // }}
          // style={{ marginTop: "-20px" }}
        >
          <div className="newuserTooltip">
            <img
              className="iconbtn top-btn"
              src={iconTooltip}
              onClick={() => {
                setModalIsOpenToTrue();
                if (html.style.overflow == "auto") {
                  html.style.overflow = "hidden";
                } else {
                  html.style.overflow = "auto";
                }
              }}
              width={60}
            />{" "}
            <span
              className="tooltiptext tooltip-bottom "
              style={{ width: "130px", top: "50px", left: "20px" }}
            >
              View Instructions
            </span>
          </div>
        </div>
        {isShown && (
          <div>
            <AnimeList
              setModalIsOpenToTrue={setModalIsOpenToTrue}
              Heading={Heading}
              InstructionswithRole={InstructionswithRole}
              SelectPage={SelectPage}
            />
          </div>
        )}
      </div>
      <ModalFilters
        sendToParent={setIsParentData}
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        fromModule="allMentorsList"
        mentorID={mentorID}
      />
      <img src={machines} alt="machines" className={classes.machines} />

      <UpperDisplaySurface
        openLoader={props.openLoader}
        closeLoader={props.closeLoader}
        selected={selected}
        setSelected={setSelected}
        totalMentors={totalMentors}
        tablePaginate={tablePaginate}
      />
      <Typography
        style={{
          fontFamily: "Montserrat",
          fontWeight: "bold",
          color: "rgba(0,0,0,0.4)",
          textAlign: "left",
          width: "100%",

          padding: "0 7% 10px",
          transform: "translateY(50px)",
        }}
      >
        Filter By :
      </Typography>
      <Box className={classes.filterContainer}>
        <div className={clsx(classes.select2Container, "newuserTooltip")}>
          <Select
            className={classes.select2}
            placeholder="Search Mentor"
            options={removeFirstItem(
              filterMentorNameData?.map((item) => ({
                value: item?.id,
                label: item?.name,
              })),
              "Search Mentor"
            )}
            styles={{
              menu: (styles) => {
                return {
                  ...styles,
                  width: "auto",
                };
              },
              option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  ...styles,
                  backgroundColor: isSelected
                    ? "#b499c7"
                    : isFocused
                    ? "#e4d7ee"
                    : "white",
                  color: isSelected ? "white" : "black",
                  cursor: isDisabled ? "not-allowed" : "default",
                };
              },
            }}
            onChange={(selected) => {
              setFilterMentorName(selected);
            }}
          />
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "77px", top: "45px", width: "130px" }}
          >
            Search Mentor
          </span>
        </div>
        <Grid container spacing={1} alignItems="center">
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              options={removeFirstItem(
                props.selectOptions?.industry_options,
                "Select Industry"
              )}
              placeholder="Industry"
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterIndustry(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search Industry
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Keyword"
              options={removeFirstItem(
                props.selectOptions?.sub_industry,
                "Select Industry Keyword"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterIndustryKeyword(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "70px", top: "47px", width: "180px" }}
            >
              Search Industry Keyword
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Function"
              options={removeFirstItem(
                props.selectOptions?._specialisation,
                "Select Function"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterFunction(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search Function
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Keyword"
              onChange={(selected) => setFilterFunctionKeyword(selected)}
              options={removeFirstItem(
                props.selectOptions?.functional_areas,
                "Select Function Keyword"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "70px", top: "47px", width: "180px" }}
            >
              Search Function Keyword
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Stage"
              options={removeFirstItem(
                props.selectOptions?.stage_of_startup_options,
                "Select Stage"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                    minWidth: "100%",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterStage(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search Stage
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={"mentorliststate"}
              placeholder="State"
              options={addNewItem(states, "Select State")}
              onChange={(selected) => setFilterState(selected)}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                    transform: "translateX(-100px)",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "77px", top: "45px", width: "130px" }}
            >
              Search State
            </span>
          </Grid>
        </Grid>
        <div className="newuserTooltip top-btn gobtnmentorlist">
          <Button
            variant="contained"
            style={{
              // marginLeft: "10px",
              fontFamily: "Montserrat",
              color: "#fff",
              fontSize: "16px",
              backgroundColor: "#3ac2d7",
            }}
            onClick={handleClickOfFilter}
          >
            GO
          </Button>
          <span className="tooltiptext filter  tooltip-bottom">
            Click to Apply Filters
          </span>
        </div>
      </Box>

      <Typography
        className="ttlmentos"
        style={{
          textAlign: "right",
          marginBottom: "10px",
          marginTop: "10px",
          padding: "0  7%",
          fontFamily: "Montserrat",
          color: "rgba(0,0,0,0.5)",
          fontWeight: "bold",
        }}
      >
        {`Total items displayed:`}{" "}
        {paginationData !== undefined &&
          `${paginationData?.totalElements} < ${paginationData?.currentPage} of ${paginationData?.numPages} >`}
      </Typography>
      <Paper className={classes.tableContainer} elevation={3}>
        {selected === types.TOTAL_MENTORS && (
          <TotalMentorsTable
            setSelectedMenu={props.setSelectedMenu}
            data={data}
            paginationData={paginationData}
            setIsModalShown={setModalVisibility}
            setMentorID={setMentorID}
          />
        )}
        {selected === types.MY_MENTORS && (
          <MyMentorsTable
            data={data}
            paginationData={paginationData}
            setSelectedMenu={props.setSelectedMenu}
          />
        )}
        {selected === types.MY_REQUESTS && (
          <TotalMentorsTable
            setSelectedMenu={props.setSelectedMenu}
            data={data}
            paginationData={paginationData}
            setIsModalShown={setModalVisibility}
            setMentorID={setMentorID}
          />
        )}
        {paginationData?.totalElements == "0" ? (
          ""
        ) : (
          <div className="pagination-box">
            {selected === types.TOTAL_MENTORS ? (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={10}
                totalItemsCount={paginationData?.totalElements}
                pageRangeDisplayed={5}
                onChange={handleChangeOfPage.bind(this)}
              />
            ) : (
              <Pagination
                activePage={currentPage2}
                itemsCountPerPage={10}
                totalItemsCount={paginationData?.totalElements}
                pageRangeDisplayed={5}
                onChange={handleChangeOfPage2.bind(this)}
              />
            )}
          </div>
        )}
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  selectOptions: state.AdminMentorListReducer.getPredefineOptionsList.list,
  tablePaginate: state.StartUpReducer.myMentorsCounter.data,
  getStepperData: state.AdminMentorReducer.getStepperList.list,
});
export default connect(mapStateToProps, {
  openLoader,
  getStepperTooltipData,
  closeLoader,
  getPredefineOptionsList,
  getMyMentorsCounter,
})(AllMentorList);
